import React from 'react'
import { useNavigate} from 'react-router-dom';
import emptybox from '../images/emptybox.png';
import '../css/no_payment.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeftLong } from '@fortawesome/free-solid-svg-icons';

export default function No_Payment() {

  const navigate = useNavigate();
  
  return (
    <div className='ss-paymensst'>
      <div className='back1'>
          <FontAwesomeIcon icon={faArrowLeftLong} onClick={() => navigate(-1)} className='back'></FontAwesomeIcon>       
      </div>
    <div className='payment-history'>
        <div className='no-users-properties'>    
        <div className='align-not-found'>
          <div className='none11-found'>
            <img src={emptybox} alt='No agents Found' className='no1-found'  />                    
          </div>
          <div className='no-title11'>No Payment Record for this week is  found at the moment</div>
        </div>
      </div>
    </div>
    </div>
  )
}
 